export default "__VITE_ASSET__CaT8cU_z__"